export default __webpack_public_path__ + "static/media/group-8464.d52f57b7.png";